/* src/app/modules/invoice/invoice/invoice-dialog-rectification.component.css */
.rf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.rf-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  margin-bottom: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.rf-summary__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.rf-summary__label {
  color: #6b7280;
}
.rf-summary__value {
  color: #1a1d23;
  font-weight: 600;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rf-summary__value--amount {
  font-variant-numeric: tabular-nums;
}
.rf-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.45;
}
.rf-warning mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #dc2626;
  flex-shrink: 0;
}
.rf-warning strong {
  display: block;
}
/*# sourceMappingURL=invoice-dialog-rectification.component.css.map */
